<template>
  <div class="search-video-standard-delivery">
    <p class="level-1">投放设置</p>

    <div class="delivery-mode">
      <delivery :form="form" :hideTwo="true" :isStandard='true' />

      <optimize-target :externalActions="externalActions" :form="form" />

      <div class="budget">
        <el-form-item prop="budget">
          <p class="level-2">预算</p>
          <el-input
            placeholder="请输入金额"
            v-model="form.budget"
            size="small"
            class="input-with-select"
          >
            <el-select
              v-model="form.budgetType"
              slot="prepend"
              placeholder="请选择"
            >
              <el-option label="日预算" value="日预算"></el-option>
              <el-option label="总预算" value="总预算"></el-option>
            </el-select>
            <span
              slot="suffix"
              style="
                margin-right: 10px;
                color: rgb(153, 153, 153);
                line-height: 32px;
              "
              >元</span
            >
          </el-input>
        </el-form-item>
      </div>

      <div class="bid">
        <p class="level-2">
          出价
          <el-popover placement="top" trigger="hover" width="230">
            <p style="font-size: 12px; line-height: 1.8">
              出价指你愿意为每次转化支付目标价格。价格的高低会影响获得的转化次数。如，如果设置的目标价格过低，你可能会错失一部分转化。出价仅作为智能优化投放的成本参考，实际仍按展示付费
            </p>
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </p>

        <el-form-item prop="bid" style="display: inline-block">
          <el-input v-model="form.bid" class="c-input" placeholder="请输入价格">
            <span
              slot="suffix"
              style="margin-right: 10px; color: rgb(153, 153, 153)"
              >元/下单</span
            >
          </el-input>
        </el-form-item>
        <span class="advise"
          ><i class="el-icon-info"></i>
          搜索是用户主动发起的行为，建议出价高于账户下通投计划，争取更多流量
        </span>
        <div class="tips">
          <el-image
            class="img"
            :src="require(`@/assets/images/simulation/icon_bao.png`)"
            fit="fit"
          ></el-image>
          <span>按展示付费(oCPM)，根据</span>
          <a
            class="link"
            href="https://school.jinritemai.com/doudian/web/article/aHMNDfneBP7r"
            target="_blank"
            rel="noopener noreferrer"
            >成本保障规则</a
          >
          <span>提供保障福利，请谨慎修改出价或定向，以免失去保障资格</span>
        </div>
      </div>

      <div class="dateTime">
        <p class="level-2">投放日期</p>
        <el-radio-group v-model="form.dateType" size="medium">
          <el-radio-button label="从今天起长期投放"></el-radio-button>
          <el-radio-button label="设置开始和结束日期"></el-radio-button>
        </el-radio-group>
        <div class="date" v-show="form.dateType == '设置开始和结束日期'">
          <el-date-picker
            v-model="form.startTime"
            :picker-options="pickerOptions"
            type="date"
            size="small"
            placeholder="请选择日期"
          >
          </el-date-picker>
          —
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptions"
            type="date"
            size="small"
            placeholder="请选择日期"
          >
          </el-date-picker>
        </div>

        <p class="level-2">投放时段</p>
        <el-radio-group v-model="form.timeIntervalType" size="medium">
          <el-radio-button label="不限"></el-radio-button>
          <el-radio-button label="指定时间段" disabled></el-radio-button>
        </el-radio-group>
      </div>

      <div class="audience-container">
        <p class="level-1">定向人群</p>
        <div class="customer-tag">
          <el-image
            style="vertical-align: -3px"
            :src="require('@/assets/images/simulation/icon_tag.png')"
            fit="cover"
          ></el-image>
          <span style="margin-left: 5px"
            >搜索行为是由用户主动发起关键词搜索表达兴趣。建议减少定向设置，避免跑量困难</span
          >
        </div>

        <custom-audience :form="form" :isSearch="true" :collapse="true" />

        <right-card
          :form="form"
          :noHeader="true"
          :isSearch="true"
          :showOther="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomAudience from "../components/customAudience.vue";
import Delivery from "../components/delivery.vue";
import optimizeTarget from "../components/optimizeTarget.vue";
import RightCard from "../components/rightCard.vue";
export default {
  components: { optimizeTarget, CustomAudience, RightCard, Delivery },
  props: {
    form: Object,
  },
  data() {
    return {
      showEffect: false,
      externalActions: [
        {
          icon: require("@/assets/images/simulation/icon_cart.svg"),
          name: "商品购买",
          content: "更多人购买商品",
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
    };
  },
  computed: {
    effectImg() {
      if (this.form.limit)
        return require(`@/assets/images/simulation/effect_mode3.svg`);
      else {
        if (this.form.deliverySpeed == "尽快投放")
          return require(`@/assets/images/simulation/effect_mode1.svg`);
        else return require(`@/assets/images/simulation/effect_mode1.1.svg`);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.search-video-standard-delivery {
  margin-top: 56px;

  .level-1 {
    line-height: 34px;
    font-weight: 500;
    font-size: 24px;
    color: #111;
  }

  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }

  .el-icon-question {
    margin-left: 3px;
    color: #d3d3d3;
    font-size: 16px;
    vertical-align: -1px;
    cursor: pointer;
  }

  ::v-deep  .el-radio-group {
    .el-radio-button__inner {
      padding-left: 15px;
      padding-right: 15px;
      min-width: 100px;
      height: 34px;
      background: #f2f2f2;
      border: 1px solid transparent;
      color: #333;

      // border-radius: 4px;
      &:hover {
        background-color: #eff0fe;
      }
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #194ce5;
      border: 1px solid #194ce5;
      background-color: #fff;
      box-shadow: none;
    }
  }

  .delivery-mode {
    .budget {
      ::v-deep .input-with-select {
        width: 373px;
        .el-input__inner {
          background-color: #f2f2f2;
        }
        .el-input-group__prepend {
          width: 99px;
          color: #333;
          background-color: #fff;
        }
      }
    }

    .bid {
      ::v-deep .c-input {
        .el-input__inner {
          background-color: #f2f2f2;
        }
      }
      .advise {
        margin-left: 9px;
        line-height: 20px;
        font-size: 12px;
        color: #333;
        .el-icon-info {
          color: #d3d3d3;
          font-size: 16px;
          vertical-align: -1px;
        }
      }
      .tips {
        margin-top: 8px;
        line-height: 18px;
        font-size: 12px;
        color: #666;
        .img {
          margin-right: 5px;
          vertical-align: top;
        }
        .link {
          margin: 0 4px;
          color: #194ce5;
        }
      }
    }

    .dateTime {
      .date {
        display: inline-block;
        margin-left: 50px;
        ::v-deep .el-date-editor {
          width: 138px;
          .el-input__inner {
            background-color: #f2f2f2;
          }
        }
      }
    }

    .audience-container {
      position: relative;
      margin-top: 56px;
      margin-bottom: 56px;
      .customer-tag {
        margin-top: 8px;
        padding: 8px;
        width: 647px;
        height: 34px;
        font-size: 14px;
        background-color: #edf1fd;
        border-radius: 4px;
        line-height: 1;
        color: #333;
      }
    }
  }
}
</style>